import api from '@/api'

// initial state
const state = {
}

// getters
const getters = {
}

// actions
const actions = {
	userLogin ({ commit, state }, payload) {
		return api.user.login({ 'Account[email]': payload.account.email, 'Account[password]': payload.account.password }, payload).then(function (data) {
			commit('authItems', data.authItems, {module: 'app'})
			commit('account', data.account, {module: 'app'})
			if (payload.callback && typeof payload.callback === 'function') {
				payload.callback(data)
			}
		})
	},
	userLogout ({ commit, state }, payload) {
		return api.user.logout(payload).then(function (data) {
			commit('authItems', ['guest'], {module: 'app'})
			commit('account', {}, {module: 'app'})
			if (payload.callback && typeof payload.callback === 'function') {
				payload.callback(data)
			}
		})
	},
	userSignup ({ commit, state }, payload) {
		return api.user.signup({ 'Account[username]': payload.account.userName, 'Account[email]': payload.account.email, 'Account[password]': payload.account.password, 'Account[verifyPassword]': payload.account.verifyPassword }, payload).then(function (data) {
			commit('authItems', ['guest'], {module: 'app'})
			commit('account', {}, {module: 'app'})
			if (payload.callback && typeof payload.callback === 'function') {
				payload.callback(data)
			}
		})
	},
	userActivate ({ commit, state }, payload) {
		return api.user.activate({ 'token': payload.account.token }, payload).then(function (data) {
			commit('authItems', ['guest'], {module: 'app'})
			commit('account', {}, {module: 'app'})
			if (payload.callback && typeof payload.callback === 'function') {
				payload.callback(data)
			}
		})
	},
	userForgotPassword ({ commit, state }, payload) {
		return api.user.forgot({ 'Account[email]': payload.account.email }, payload).then(function (data) {
			commit('authItems', ['guest'], {module: 'app'})
			commit('account', {}, {module: 'app'})
			if (payload.callback && typeof payload.callback === 'function') {
				payload.callback(data)
			}
		})
	},
	userResetPassword ({ commit, state }, payload) {
		return api.user.reset({ 'token': payload.account.token, 'Account[password]': payload.account.password, 'Account[verifyPassword]': payload.account.verifyPassword }, payload).then(function (data) {
			commit('authItems', ['guest'], {module: 'app'})
			commit('account', {}, {module: 'app'})
			if (payload.callback && typeof payload.callback === 'function') {
				payload.callback(data)
			}
		})
	},
	userCheckToken ({ commit, state }, payload) {
		return api.user.check({ 'token': payload.account.token }, payload).then(function (data) {
			commit('authItems', ['guest'], {module: 'app'})
			commit('account', {}, {module: 'app'})
			if (payload.callback && typeof payload.callback === 'function') {
				payload.callback(data)
			}
		})
	}
}

// mutations
const mutations = {
}

export default {
  state,
  getters,
  actions,
  mutations
}



// WEBPACK FOOTER //
// ./src/store/modules/user.js